import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid3x3, Search, ShoppingCart, User } from 'lucide-react';
import { useShopCart } from '@/context/ShopCartContext';
import { useShopOrg } from '@/context/ShopOrgContext';

const MobileBottomNav = () => {
  const location = useLocation();
  const { cartCount, setCartOpen } = useShopCart();
  const { slug } = useShopOrg();

  const isActive = (path) => location.pathname === path;
  const linkClass = (path) => `flex flex-col items-center gap-0.5 px-3 py-1 text-xs ${isActive(path) ? 'text-teal-600' : 'text-slate-500'}`;

  return (
    <nav className="fixed bottom-0 inset-x-0 bg-white border-t border-slate-100 flex items-center justify-around py-2 sm:hidden z-30">
      <Link to={`/${slug}/shop`} className={linkClass(`/${slug}/shop`)}>
        <Home className="w-5 h-5" />
        Home
      </Link>
      <Link to={`/${slug}/shop/products`} className={linkClass(`/${slug}/shop/products`)}>
        <Grid3x3 className="w-5 h-5" />
        Producten
      </Link>
      <Link to={`/${slug}/shop/products`} className="flex flex-col items-center gap-0.5 px-3 py-1 text-xs text-slate-500">
        <Search className="w-5 h-5" />
        Zoeken
      </Link>
      <button type="button" onClick={() => setCartOpen(true)} className="relative flex flex-col items-center gap-0.5 px-3 py-1 text-xs text-slate-500">
        <ShoppingCart className="w-5 h-5" />
        Winkelwagen
        {cartCount > 0 && (
          <span className="absolute top-0 right-1 bg-teal-600 text-white text-[9px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
            {cartCount}
          </span>
        )}
      </button>
      <Link to={`/${slug}/shop/account`} className={linkClass(`/${slug}/shop/account`)}>
        <User className="w-5 h-5" />
        Account
      </Link>
    </nav>
  );
};

export default MobileBottomNav;
